/*eslint-disable */
define(function (require) {
    'use strict';

    var Backbone = require('backbone');

    var BasketSummaryServiceModel = Backbone.Model.extend({
        defaults: {
            serviceId: '',
            name: '',
            duration: {
                unit: 'MINUTE',
                value: 0
            },
            skus: [
                {
                    name: '',
                    price: 0
                }
            ]
        },

        initialize: function (modelData) {
            this.set('id', modelData.serviceId);
        }
    });

    return BasketSummaryServiceModel;
});
